module.exports = __webpack_public_path__ + "img/idx.85270d31.png";